(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var navbar = document.querySelector('.navbar');
    var menu = document.getElementById('mmenu');
    var ham = document.getElementById('mham');

    if (navbar) {
      window.addEventListener(
        'scroll',
        function () {
          navbar.classList.toggle('scrolled', window.scrollY > 8);
        },
        { passive: true }
      );
    }

    if (!menu || !ham) return;

    function shut() {
      menu.classList.remove('on');
      ham.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    ham.addEventListener('click', function (e) {
      e.preventDefault();
      menu.classList.add('on');
      ham.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });

    menu.querySelector('.mx').addEventListener('click', function (e) {
      e.preventDefault();
      shut();
    });

    Array.prototype.forEach.call(menu.querySelectorAll('.mlinks a, .mcta'), function (a) {
      a.addEventListener('click', shut);
    });

    var mcart = menu.querySelector('.mcart');
    if (mcart) {
      mcart.addEventListener('click', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.open !== 'function') return;
        e.preventDefault();
        shut();
        drawer.open();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('on')) shut();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-upsell"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var box = document.getElementById('cart-bump');
    var check = document.getElementById('cart-bump-check');
    if (!box || !check) return;
    var busy = false;

    check.addEventListener('change', function () {
      if (busy) return;
      busy = true;
      check.disabled = true;

      if (typeof gtag === 'function') {
        gtag('event', 'upsell_toggle', { location: 'cart', action: check.checked ? 'on' : 'off' });
      }

      var id = parseInt(box.dataset.upsellId, 10);
      var req;

      if (check.checked) {
        req = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        });
      } else {
        // The discount can split this variant across several lines, and change.js
        // keyed by variant id misfires then. Decrement the last matching line only.
        req = fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var lineNo = -1;
            for (var i = 0; i < cart.items.length; i++) {
              if (cart.items[i].variant_id === id) lineNo = i + 1;
            }
            if (lineNo < 0) throw new Error('upsell line not found');
            var line = cart.items[lineNo - 1];
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: lineNo, quantity: Math.max(0, line.quantity - 1) })
            });
          });
      }

      req
        .then(function (r) {
          if (!r.ok) throw new Error('cart request failed');
          window.location.reload();
        })
        .catch(function () {
          busy = false;
          check.disabled = false;
          check.checked = !check.checked;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faqq .hd').forEach(function (h) {
    function toggle() {
      var open = h.parentElement.classList.toggle('open');
      h.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    h.addEventListener('click', toggle);
    h.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.sciopt').forEach(function (b) {
    b.addEventListener('click', function () {
      var i = b.dataset.i;
      document.querySelectorAll('.sciopt').forEach(function (x) {
        x.classList.toggle('active', x.dataset.i === i);
      });
      document.querySelectorAll('.scipanel').forEach(function (p) {
        p.classList.toggle('active', p.dataset.i === i);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-buy-simple"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[id^="pbs-"]').forEach(function (root) {
    var form = root.querySelector('.pbs-form');
    if (form && !form.querySelector('input[name="return_to"]')) {
      form.addEventListener('submit', function (e) {
        if (typeof window.ffAddToCartAndOpenDrawer !== 'function') return;
        if (!document.querySelector('cart-drawer')) return;
        e.preventDefault();
        var idInput = root.querySelector('[data-pbs-id]');
        var qtyInput = form.querySelector('input[name="quantity"]');
        var atc = root.querySelector('[data-pbs-atc]');
        if (atc) atc.disabled = true;
        window
          .ffAddToCartAndOpenDrawer(parseInt(idInput.value, 10), qtyInput ? parseInt(qtyInput.value, 10) : 1)
          .catch(function () {
            form.submit();
          })
          .finally(function () {
            if (atc) atc.disabled = false;
          });
      });
    }
    var sel = root.querySelector('[data-pbs-variants]');
    if (sel) {
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        var idInput = root.querySelector('[data-pbs-id]');
        if (idInput) idInput.value = opt.value;
        var price = root.querySelector('[data-pbs-price]');
        if (price && opt.dataset.price) price.textContent = opt.dataset.price;
        var was = root.querySelector('[data-pbs-was]');
        var wasnote = root.querySelector('[data-pbs-wasnote]');
        if (was) {
          if (opt.dataset.was) {
            was.textContent = opt.dataset.was;
            was.hidden = false;
            if (wasnote) wasnote.hidden = false;
          } else {
            was.hidden = true;
            if (wasnote) wasnote.hidden = true;
          }
        }
        var main = root.querySelector('[data-pbs-main]');
        if (main && opt.dataset.image) { main.srcset = opt.dataset.image; main.src = opt.dataset.image; }
        var atc = root.querySelector('[data-pbs-atc]');
        if (atc) atc.disabled = opt.disabled;
      });
    }
    root.querySelectorAll('.thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        var main = root.querySelector('[data-pbs-main]');
        if (main && t.dataset.full) { main.srcset = t.dataset.full; main.src = t.dataset.full; }
        root.querySelectorAll('.thumb').forEach(function (x) {
          x.classList.remove('sel');
        });
        t.classList.add('sel');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-buy"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      var main = document.getElementById('mainimg');
      if (main && t.dataset.full) main.src = t.dataset.full;
      document.querySelectorAll('.thumb').forEach(function (x) {
        x.classList.remove('sel');
      });
      t.classList.add('sel');
    });
  });

  (function () {
    var bump = document.getElementById('bump-box');
    var check = document.getElementById('bump-check');

    function withBump(url) {
      if (!bump || bump.hidden || !check || !check.checked) return url;
      var up = bump.dataset.upsellId;
      var m = (url || '').match(/^\/cart\/(\d+):(\d+)$/);
      if (!m) return url;
      if (m[1] === up) return '/cart/' + up + ':' + (parseInt(m[2], 10) + 1);
      return url + ',' + up + ':1';
    }

    var tierClicked = false;

    function refresh() {
      var o = document.querySelector('.offer.sel[data-sel]');
      var c = document.getElementById('buycta');
      if (!o || !c) return;
      if (bump) {
        var tiers = (bump.dataset.tiers || '').split(',');
        bump.hidden = !tierClicked || tiers.indexOf(o.dataset.sel) < 0;
        if (bump.hidden && check) check.checked = false;
      }
      c.href = withBump(o.dataset.url);
      if (o.dataset.cta) c.textContent = o.dataset.cta;
    }

    document.querySelectorAll('.offer[data-sel]').forEach(function (o) {
      o.addEventListener('click', function () {
        tierClicked = true;
        document.querySelectorAll('.offer[data-sel]').forEach(function (x) {
          x.classList.toggle('sel', x === o);
        });
        refresh();
      });
    });

    if (check) {
      check.addEventListener('change', function () {
        refresh();
        if (typeof gtag === 'function') {
          gtag('event', 'upsell_toggle', { location: 'buybox', action: check.checked ? 'on' : 'off' });
        }
      });
    }

    refresh();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["protocol-picker"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var stack = document.querySelector('.ostack');
    if (!stack) return;
    var bump = document.getElementById('pk-bump');
    var check = document.getElementById('pk-bump-check');
    var baseUrl = '';
    var tierClicked = false;

    function el(name) {
      return stack.querySelector('[data-el="' + name + '"]');
    }

    function withBump(url) {
      if (!bump || bump.hidden || !check || !check.checked) return url;
      var up = bump.dataset.upsellId;
      var m = (url || '').match(/^\/cart\/(\d+):(\d+)$/);
      if (!m) return url;
      if (m[1] === up) return '/cart/' + up + ':' + (parseInt(m[2], 10) + 1);
      return url + ',' + up + ':1';
    }

    function refreshCta() {
      var cta = el('octa');
      if (cta) cta.href = withBump(baseUrl);
    }

    function setTier(btn) {
      var t = btn.dataset.t;
      document.querySelectorAll('.tb').forEach(function (b) {
        b.classList.toggle('active', b === btn);
      });
      stack.querySelectorAll('.oi[data-in]').forEach(function (li) {
        li.classList.toggle('off', li.dataset.in.split(',').indexOf(t) < 0);
      });
      var tubn = stack.querySelector('.tubn');
      if (tubn) tubn.textContent = btn.dataset.tub;
      el('tubval').textContent = btn.dataset.tubval;
      el('totval').textContent = btn.dataset.tot;
      el('paybig').textContent = btn.dataset.pay;
      el('persm').textContent = btn.dataset.per;
      el('savel').textContent = btn.dataset.save;
      var cta = el('octa');
      cta.textContent = btn.dataset.cta;
      baseUrl = btn.dataset.url;
      if (bump) {
        var tiers = (bump.dataset.tiers || '').split(',');
        bump.hidden = !tierClicked || tiers.indexOf(t) < 0;
        if (bump.hidden && check) check.checked = false;
      }
      refreshCta();
      var pay = el('paybig');
      pay.classList.remove('pulse');
      void pay.offsetWidth;
      pay.classList.add('pulse');
    }

    document.querySelectorAll('.tb').forEach(function (b) {
      b.addEventListener('click', function () {
        tierClicked = true;
        setTier(b);
      });
    });

    if (check) {
      check.addEventListener('change', function () {
        refreshCta();
        if (typeof gtag === 'function') {
          gtag('event', 'upsell_toggle', { location: 'picker', action: check.checked ? 'on' : 'off' });
        }
      });
    }

    var featured = document.querySelector('.tb.feat') || document.querySelector('.tb');
    if (featured) setTier(featured);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var st = document.getElementById('stars');
    if (!st) return;
    var v = 0;
    var sp = [].slice.call(st.querySelectorAll('span'));
    function paint(n) {
      sp.forEach(function (s, i) {
        s.classList.toggle('on', i < n);
      });
    }
    sp.forEach(function (s, i) {
      s.addEventListener('mouseenter', function () {
        paint(i + 1);
      });
      s.addEventListener('click', function () {
        v = i + 1;
        paint(v);
      });
    });
    st.addEventListener('mouseleave', function () {
      paint(v);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-accordions"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.acc .hd').forEach(function (h) {
      function toggle() {
        var open = h.parentElement.classList.toggle('open');
        h.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      h.addEventListener('click', toggle);
      h.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });

    function openHash() {
      var id = (location.hash || '').slice(1);
      if (!id) return;
      var el = document.getElementById(id);
      if (el && el.classList.contains('acc')) {
        el.classList.add('open');
        window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
      }
    }
    window.addEventListener('hashchange', openHash);
    openHash();

    if (window.matchMedia('(max-width:900px)').matches) {
      document.querySelectorAll('.acc.open').forEach(function (a) {
        a.classList.remove('open');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.sciov').forEach(function (ov) {
    var section = ov.closest('.shopify-section') || document;
    var pop = ov.querySelector('.scipop');
    var title = pop.querySelector('h3');
    var body = pop.querySelector('p');

    function open(pillar) {
      title.textContent = pillar.getAttribute('data-t');
      body.textContent = pillar.getAttribute('data-b');
      ov.classList.add('on');
    }

    function close(e) {
      if (e) e.preventDefault();
      ov.classList.remove('on');
    }

    document.querySelectorAll('.pillar').forEach(function (pillar) {
      pillar.addEventListener('click', function () {
        open(pillar);
      });
      pillar.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open(pillar);
        }
      });
    });

    pop.querySelector('.x').addEventListener('click', close);
    ov.addEventListener('click', function (e) {
      if (e.target === ov) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signup-popup"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ov[data-delay]').forEach(function (ov) {
    var key = 'ff-popup-dismissed';
    try {
      if (sessionStorage.getItem(key)) return;
    } catch (e) {
      /* storage unavailable, still show once */
    }

    function close(e) {
      if (e) e.preventDefault();
      ov.classList.remove('on');
      try {
        sessionStorage.setItem(key, '1');
      } catch (e2) {
        /* noop */
      }
    }

    var shown = false;
    var scrollTrigger = parseFloat(ov.getAttribute('data-scroll-trigger')) || 0;
    var scrollHandler;
    var delayTimer;

    function show() {
      if (shown) return;
      shown = true;
      ov.classList.add('on');
      if (scrollHandler) window.removeEventListener('scroll', scrollHandler);
      if (delayTimer) window.clearTimeout(delayTimer);
    }

    if (scrollTrigger > 0) {
      scrollHandler = function () {
        var pageHeight = document.documentElement.scrollHeight - window.innerHeight;
        if (pageHeight > 0 && (window.scrollY / pageHeight) * 100 >= scrollTrigger) show();
      };
      window.addEventListener('scroll', scrollHandler, { passive: true });
      scrollHandler();
    }

    delayTimer = window.setTimeout(show, parseFloat(ov.getAttribute('data-delay')) * 1000);

    ov.querySelectorAll('[data-pop-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    ov.addEventListener('click', function (e) {
      if (e.target === ov) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-scroll"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    var els = [].slice.call(document.querySelectorAll('.fstext, .fsimg, .pull'));
    els.forEach(function (el) {
      el.classList.add('reveal');
    });
    var io = new IntersectionObserver(
      function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
